import React, {useState, useRef, useEffect} from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge,Spinner,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,

} from "reactstrap";
import { useSelector , useDispatch} from 'react-redux'

import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
  floattest, numtest} from '../../../../helpers/validate'
import {customStyles} from '../../../../helpers/mycomps'
import dp from "../../../images/dp.jpg"

import { areaFetch} from "../../../../actions/actions"

function Brandreq(props) {
    const [showProcessing , setShowProcessing] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [selectedbrand, setSelectedBrand] = useState({
        bid : "", bname : {en : "", fr :"", ar : ""},
        blogo : ""
    })

    const [{alt, src}, setImg] = useState({
        src: dp,
        alt: ''
      });
      const [alert, setAlert] = React.useState(null);
    const [filenames, setFilenames] = useState()
    const hiddenFileInput = useRef(null);
    
    const populatebrands = () => {
        props.API.get(`tenant/getbrands`, {headers : {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            setBrandList(res.data.map(r => {
                return {
                    ...r, value : r.bid, label : r.bname.en,
                    blogo : r.blogo
                }
            }))
         
                          
          }).catch(function (error) {
              
              console.log(error)
              props.basicAlert("Error configuring City")
          }) 
    }

    const cinputConfirmAlert = (xcc) => {
        let mtext = ""
        setAlert(
          <ReactBSAlert
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => {hideAlert(); updbrand()}}
            onCancel={() => {hideAlert();}}
            confirmBtnBsStyle="info"
            btnSize=""
            showCancel
            title={
              <p style={{fontSize : "1rem"}}>
               Are you sure you want to <b>{mtext}</b>
              </p>
            }
          />
        );
      };  

      const handleClick = event => {
        hiddenFileInput.current.click();
      };
   
    const hideAlert = () => {
        setAlert(null);
      };

    const handleImg = (e) => {
    
        if(e.target.files[0]) {
                
            if(filenamevalid(e.target.files[0])){
              setFilenames(e.target.files[0])
              setImg({
                src: URL.createObjectURL(e.target.files[0]),
                alt: e.target.files[0].name
            });
            }else{
              props.basicAlert("Invalid Filename")
            }
        }
     
          
    }

    const updbrand = () => {
      if(fieldvalidator(selectedbrand.bname.en )){
        props.basicAlert("Required Fields are EMPTY!")
        return 
      }
        setShowProcessing(true)
        let formData = new FormData(); 
        formData.append("blogo" , filenames)
        formData.append('brand' , JSON.stringify(selectedbrand))
        props.API({
            method: "post",
            url : `ten/brandreq`,
            data: formData,
            headers : {"arixauth" : localStorage.getItem("arixauth")}
            }).then((res) => {
              props.basicAlert("Brand request created!")
              setShowProcessing(false)
         //     populatebrands()
            }).catch(function (error) {
              setShowProcessing(false)
               console.log(error.response.data.message)
        }) 

    }

    useEffect(() => {
    
        setSelectedBrand(props.selectedbrand)
    }, [props.selectedbrand])

   
     return (
      
        <div className="content">
             {alert}

             <input
         ref={hiddenFileInput}
         type="file" 
         accept=".png, .jpg, .jpeg" 
         id="photo" 
         className="visually-hidden"
         onChange={e=> handleImg(e)}
         hidden/>
      
        <Row>
            {/** This will contain Table */}
            <Col sm="12" md="12">
            {showProcessing ? <center><Spinner /></center> : 
            
             <Card>
                 <CardHeader>
              
                 <Row>
                 <Col>
                 <center>
                   <img className="mute-anim" src = {selectedbrand.blogo === "" ? src : `${selectedbrand.blogo}`} alt={"..."} width="150px"  onClick={e => {
                                handleClick(e)
                              }}/>
                   </center>
                 </Col>   
                 </Row>     
                                           
                 <Row>
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             value = {selectedbrand.bname.en}
                             placeholder="en"
                             type="text"
                             readOnly
                              onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, en : t.target.value}})
                                
                                }
                            }
                              
                             />
                         </FormGroup>
                         </Col>
                         {/** 
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                           value = {selectedbrand.bname.fr}
                             placeholder="Nom"
                             type="text"
                             onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, fr : t.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                              value = {selectedbrand.bname.ar}
                             placeholder="اسم"
                             type="text"
                             readOnly
                             onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, ar : t.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col>
                  </Row>
                 
           
                 </CardHeader>
                 <CardBody>
               
                 </CardBody>
                 <CardFooter>
                    
                     <Button size="sm" color="warning" style={{float : "right", display : props.selectedbrand.reqid !== "" ? "none" : "block" }} onClick={x => {
                        cinputConfirmAlert()
                     }}>Request</Button>
                 </CardFooter>
             </Card>}
         </Col>
           
        </Row>
        </div>
    )
}

export default Brandreq;